import React, { useEffect, useState } from "react";
import { Button, Card, Grid, Tab, Tabs, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import useStyles from "./styles";
import CeroChipSelect from "../../../components/CeroChipSelect";
import CountriesIcon from "../../../assets/icons/CountriesIcon.png";
import FacilitiesIcon from "../../../assets/icons/FacilitiesIcon.png";
import durationIcon from "../../../assets/icons/durationIcon.png";
import EnvironmentalIcon from "../../../assets/icons/EnvironmentalIcon.png";
import SocialIcon from "../../../assets/icons/social&governance.png";
import EnergySourceIcon from "../../../assets/icons/energy-sources.png";
import { getCookie } from "../../../services/cookie";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const DashboardFilter = (props) => {
  const { onApplyFilter, isWidgetPanelOpen } = props;
  const role = getCookie("role");
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const readOnlyMode = getCookie("read_only_mode") === "disable_edit";
  const { type } = useParams();

  const classes = useStyles();
  const facilitiesData = useSelector(
    (state) => state.listings.listFacilities.data
  );
  const countryData = useSelector(
    (state) => state.listings.getOrganizationCountry.data.country_data
  );
  const facilitiesList = facilitiesData.map((item) => ({
    key: item.id,
    value: item.name,
  }));
  facilitiesList.splice(0, 0, { key: "all", value: "All" });

  const [filterPeriod, setPeriod] = useState([]);
  const [filterCountry, setCountry] = useState([]);
  const [filterCountryFacility, setCountryFacility] = useState([]);
  const [energySources, setEnergySources] = useState([]);
  const countryFacilityData = useSelector(
    (state) => state.listings.getOrganizationCountry.data.country_facility_data
  );
  const countryFacilityDataObject = {};
  for (const key in countryFacilityData) {
    Object.assign(countryFacilityDataObject, countryFacilityData[key]);
  }
  const [facilitites, setFacility] = useState(countryFacilityDataObject);
  const countryCount = filterCountry.length ? filterCountry.length : "All";
  const facilityCount = filterCountryFacility.length
    ? filterCountryFacility.length
    : "All";

  const selectionPeriodObject = {
    "Last six months": "last_six_months",
    "Last one year": "last_one_year",
    "Last five years": "last_five_years",
  };

  const selectionEnergySourceObject = {
    "Stationary Combustion": "stationary_combustion",
    "Mobile Combustion": "mobile_combustion",
    Refrigerants: "refrigerants",
    Transportation: "transportation",
    "Purchased Electricity": "purchased_electricity",
    Water: "water",
    Waste: "waste",
  };

  const iconMapping = {
    Environmental: <img src={EnvironmentalIcon} alt="Environmental" />,
    "Social & Governance": <img src={SocialIcon} alt="Social & Governance" />,
  };

  const getFacility = (countries) => {
    const countryFacilityDataObject = {};
    var availableFacility = [];
    for (const item of countries) {
      Object.assign(
        countryFacilityDataObject,
        countryFacilityData[countryData[item]]
      );
      availableFacility = availableFacility.concat(
        Object.keys(countryFacilityData[countryData[item]])
      );
    }
    const persistedfacilitySelection = availableFacility.filter((element) =>
      filterCountryFacility.includes(element)
    );
    setFacility(countryFacilityDataObject);
    setCountryFacility(persistedfacilitySelection);
  };

  const countryHandleChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setCountry(
        filterCountry.length === Object.keys(countryData).length
          ? []
          : Object.keys(countryData)
      );

      getFacility(
        filterCountry.length === Object.keys(countryData).length
          ? []
          : Object.keys(countryData)
      );
      return;
    }
    setCountry(value);
    getFacility(value);
  };

  const facilityHandleChange = (event) => {
    const value = event.target.value;
    var avlData = [];
    if (value[value.length - 1] === "all") {
      avlData =
        filterCountryFacility.length === Object.keys(facilitites).length
          ? []
          : Object.keys(facilitites);
    } else {
      avlData = value;
    }
    setCountryFacility(avlData);
  };

  const energySourceHandleChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setEnergySources(
        energySources.length === Object.keys(selectionEnergySourceObject).length
          ? []
          : Object.keys(selectionEnergySourceObject)
      );
      return;
    }
    setEnergySources(value);
  };

  useEffect(() => {
    onApply();
  }, [filterPeriod, energySources, filterCountryFacility, filterCountry]);

  const durationHandleChange = (event) => {
    const value = event.target.value;
    if (value.length > 0) {
      setPeriod([value[value.length - 1]]);
    } else {
      setPeriod([]);
    }
  };

  const handleChange = (event, newValue) => {
    props.setValue(newValue);
  };

  const onApply = () => {
    const filterValue = {};
    if (filterPeriod.length > 0) {
      const selectedPeriodKey = selectionPeriodObject[filterPeriod];
      filterValue.duration = selectedPeriodKey;
    } else {
      filterValue.duration = "last_one_year";
    }
    if (filterCountryFacility.length > 0) {
      filterValue.facility_id = [];
      filterCountryFacility.map((item) =>
        filterValue.facility_id.push(countryFacilityDataObject[item])
      );
    }

    if (filterCountry.length) {
      filterValue.countries = [];
      filterCountry.map((item) =>
        filterValue.countries.push(countryData[item])
      );
    }
    if (energySources.length) {
      filterValue.emission_types = [];
      energySources.map((item) =>
        filterValue.emission_types.push(selectionEnergySourceObject[item])
      );
    }
    onApplyFilter(filterValue);
  };

  const selectedPeriod =
    filterPeriod.length > 0 ? filterPeriod : ["Last one year"];

  return (
    <>
      <Card className={classes.card}>
        {(role === "sustainability_manager" ||
          role === "read_only_user" ||
          role === "proxy_sustainability_manager") && (
          <>
            {pathname.includes("dashboard/details") ? (
              <div
                className={classes.backContainer}
                onClick={() => {
                  navigate(-1);
                }}
              >
                <ArrowBackIosIcon />
                Back
              </div>
            ) : role !== "read_only_user" ? (
              <div className={classes.tabsContainer}>
                {(props.canShowEnvtab || props.canShowSGtab) && (
                  <Tabs
                    value={
                      [
                        props.canShowEnvtab ? 0 : null,
                        props.canShowSGtab ? 1 : null,
                      ].includes(props.value)
                        ? props.value
                        : props.canShowEnvtab
                        ? 0
                        : 1
                    }
                    className={classes.tabs}
                    onChange={(e, v) => props.setValue(v)}
                    variant="scrollable"
                    scrollButtons={false}
                  >
                    {props.canShowEnvtab && (
                      <Tab
                        value={0}
                        className={classes.tabOption}
                        style={{
                          backgroundColor:
                            props.value === 0 ? "#e4e4e4" : "transparent",
                          color: props.value === 0 ? "white" : "inherit",
                          border:
                            props.value === 0
                              ? "1px solid #8C2148"
                              : "1px solid #E0E0E0",
                          borderRadius: 10,
                          fontSize: "14px",
                          marginRight: "24px",
                          padding: "6px 12px",
                          width: "auto",
                        }}
                        label={
                          <div className={classes.tabLabel}>
                            <img src={EnvironmentalIcon} alt="Environmental" />
                            <span className={classes.tabTitle}>
                              Environmental
                            </span>
                          </div>
                        }
                      />
                    )}

                    {props.canShowSGtab && (
                      <Tab
                        value={1}
                        className={classes.tabOption}
                        style={{
                          backgroundColor:
                            props.value === 1 ? "#e4e4e4" : "transparent",
                          color: props.value === 1 ? "white" : "inherit",
                          border:
                            props.value === 1
                              ? "1px solid #8C2148"
                              : "1px solid #E0E0E0",
                          borderRadius: 10,
                          fontSize: "14px",
                          marginRight: "10px",
                          padding: "6px 12px",
                          minWidth: "185px",
                          justifyContent: "center",
                        }}
                        label={
                          <div className={classes.tabLabel}>
                            <img src={SocialIcon} alt="Social & Governance" />
                            <span className={classes.tabTitle}>
                              Social & Governance
                            </span>
                          </div>
                        }
                      />
                    )}
                  </Tabs>
                )}
              </div>
            ) : (
              <></>
            )}
          </>
        )}
        <Grid
          className={
            role === "sustainability_manager" ||
            role === "read_only_user" ||
            role === "proxy_sustainability_manager"
              ? classes.adjustedHead
              : classes.headClass
          }
        >
          <Grid
            container
            alignItems="center"
            wrap="nowrap"
            className={`${classes.filterRow} ${
              isWidgetPanelOpen ? classes.filterRowDense : ""
            }`}
            justifyContent={
              role === "sustainability_manager" ||
              role === "read_only_user" ||
              role === "proxy_sustainability_manager"
                ? "space-between"
                : "flex-end"
            }
          >
            <Grid
              container
              spacing={isWidgetPanelOpen ? 1 : 2}
              alignItems="center"
              wrap="nowrap"
              justifyContent={
                isWidgetPanelOpen
                  ? "flex-start"
                  : role === "sustainability_manager" ||
                    role === "read_only_user" ||
                    role === "proxy_sustainability_manager"
                  ? "space-between"
                  : "flex-end"
              }
              style={{
                ...(role !== "sustainability_manager" &&
                role !== "read_only_user" &&
                role !== "proxy_sustainability_manager"
                  ? pathname.includes("dashboard-config")
                    ? { padding: "12px 16px", width: "100%" }
                    : {
                        marginRight: 0,
                        marginLeft: "auto",
                        width: "fit-content",
                      }
                  : { marginLeft: "14px" }),
              }}
            >
              <Grid item xs="auto">
                <Typography
                  variant="body1"
                  className={`${classes.filterText} ${
                    isWidgetPanelOpen ? classes.filterTextCompact : ""
                  }`}
                >
                  Filter by:
                </Typography>
              </Grid>

              {type !== "initiatives" && type !== "emc" && (
                <Grid
                  item
                  xs={2.5}
                  className={isWidgetPanelOpen ? classes.gridItemCompact : ""}
                >
                  <CeroChipSelect
                    label={
                      <div
                        className={`${classes.labels} ${
                          isWidgetPanelOpen ? classes.labelsCompact : ""
                        }`}
                      >
                        <img
                          src={CountriesIcon}
                          alt="Countries"
                          height="16"
                          width="16"
                        />
                        <Typography
                          className={`${classes.labelText} ${
                            isWidgetPanelOpen ? classes.labelTextCompact : ""
                          }`}
                        >
                          Country{" "}
                          <span style={{ color: "#6A6969" }}>
                            {" "}
                            ({countryCount})
                          </span>
                        </Typography>
                      </div>
                    }
                    formControlClass={`${classes.multiSelect} ${
                      isWidgetPanelOpen ? classes.multiSelectCompact : ""
                    }`}
                    optionsde={countryData}
                    selected={filterCountry}
                    handleChange={countryHandleChange}
                    classes={{
                      justCheckSelected: classes.justCheckSelected,
                      label: classes.label,
                    }}
                    shrink={false}
                    renderValue={() => null}
                  />
                </Grid>
              )}

              {type !== "initiatives" && type !== "emc" && (
                <Grid
                  item
                  xs={2.5}
                  className={isWidgetPanelOpen ? classes.gridItemCompact : ""}
                >
                  <CeroChipSelect
                    label={
                      <div
                        className={`${classes.labels} ${
                          isWidgetPanelOpen ? classes.labelsCompact : ""
                        }`}
                      >
                        <img
                          src={FacilitiesIcon}
                          alt="Facility"
                          height="16"
                          width="16"
                        />
                        <Typography
                          className={`${classes.labelText} ${
                            isWidgetPanelOpen ? classes.labelTextCompact : ""
                          }`}
                        >
                          Facility{" "}
                          <span style={{ color: "#6A6969" }}>
                            {" "}
                            ({facilityCount})
                          </span>
                        </Typography>
                      </div>
                    }
                    formControlClass={`${classes.multiSelect} ${
                      isWidgetPanelOpen ? classes.multiSelectCompact : ""
                    }`}
                    optionsde={
                      Object.keys(facilitites).length > 0
                        ? facilitites
                        : countryFacilityDataObject
                    }
                    selected={filterCountryFacility}
                    handleChange={facilityHandleChange}
                    classes={{
                      justCheckSelected: classes.justCheckSelected,
                      label: classes.label,
                    }}
                    shrink={false}
                    renderValue={() => null}
                    sortOption={true}
                  />
                </Grid>
              )}

              {type === "emc" && (
                <Grid item xs={3}>
                  <CeroChipSelect
                    label={
                      <div className={classes.labels}>
                        <img
                          src={EnergySourceIcon}
                          alt="Energy Source"
                          height="16"
                          width="16"
                          // style={{ marginRight: 5, marginLeft: 5 }}
                        />
                        <Typography className={classes.labelText}>
                          Energy Source
                          <span style={{ color: "#6A6969" }}>
                            {" "}
                            ({energySources.length || 7})
                          </span>
                        </Typography>
                      </div>
                    }
                    formControlClass={`${classes.multiSelect} ${
                      isWidgetPanelOpen ? classes.multiSelectCompact : ""
                    }`}
                    optionsde={selectionEnergySourceObject}
                    selected={energySources}
                    handleChange={energySourceHandleChange}
                    classes={{
                      justCheckSelected: classes.justCheckSelected,
                      label: classes.label,
                    }}
                    showSelectAll={true}
                    shrink={false}
                    renderValue={() => null}
                  />
                </Grid>
              )}
              <Grid
                item
                xs={2.5}
                className={isWidgetPanelOpen ? classes.gridItemCompact : ""}
              >
                <CeroChipSelect
                  label={
                    <div
                      className={`${classes.labels} ${
                        isWidgetPanelOpen ? classes.labelsCompact : ""
                      }`}
                    >
                      <img
                        src={durationIcon}
                        alt="Duration"
                        height="16"
                        width="16"
                      />
                      <Typography
                        className={`${classes.labelText} ${
                          isWidgetPanelOpen ? classes.labelTextCompact : ""
                        }`}
                      >
                        Duration <span style={{ color: "#6A6969" }}> (1)</span>
                      </Typography>
                    </div>
                  }
                  formControlClass={`${classes.multiSelect} ${
                    isWidgetPanelOpen ? classes.multiSelectCompact : ""
                  }`}
                  optionsde={selectionPeriodObject}
                  selected={selectedPeriod}
                  handleChange={durationHandleChange}
                  classes={{
                    justCheckSelected: classes.justCheckSelected,
                    label: classes.label,
                  }}
                  showSelectAll={false}
                  shrink={false}
                  renderValue={() => null}
                />
              </Grid>

              {props.isShowConfigButton && role !== "read_only_user" && (
                <Grid item alignSelf="center">
                  <Button
                    className={classes.buttonPrimaryConfig}
                    variant="contained"
                    onClick={() => navigate(`/dashboard-config`)}
                    disabled={readOnlyMode}
                    style={{
                      marginLeft:
                        role !== "sustainability_manager" &&
                        role !== "read_only_user" &&
                        role !== "proxy_sustainability_manager"
                          ? "12px"
                          : "12px",
                      alignSelf: "center",
                    }}

                    // disabled={}
                  >
                    Configure Dashboard
                  </Button>
                </Grid>
              )}
            </Grid>
            {/* <Grid item xs></Grid> */}
          </Grid>
        </Grid>
      </Card>
    </>
  );
};

export default DashboardFilter;
